import React from 'react';
import { motion } from 'framer-motion';
export function StepsSection() {
  const steps = [{
    title: 'Apply the 7-Minute "Cooling" Protocol',
    desc: 'Do this before bed to lower your heart rate and core temperature.'
  }, {
    title: 'Anchor your dinner',
    desc: 'Eat specific foods that stabilize your blood sugar throughout the night.'
  }, {
    title: 'Wake up de-puffed and energized',
    desc: 'As your body utilizes abdominal fat for fuel while you sleep.'
  }];
  return <section className="bg-cream pt-12 pb-10" data-id="element-212">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-213">
        <div className="text-center mb-8" data-id="element-214">
          <h2 className="text-sm font-bold tracking-widest text-gold uppercase mb-3" data-id="element-215">
            The Process
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold" data-id="element-216">How It Works</h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16 relative" data-id="element-217">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-10 left-16 right-16 h-0.5 bg-gold/30 z-0" data-id="element-218"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-219">
              <div className="w-20 h-20 rounded-full bg-white border-4 border-cream shadow-md flex items-center justify-center text-3xl font-bold text-gold mb-6" data-id="element-220">
                {index + 1}
              </div>
              <h4 className="text-xl font-bold text-deep-teal mb-3" data-id="element-221">
                {step.title}
              </h4>
              <p className="text-gray-600" data-id="element-222">{step.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white p-8 md:p-10 rounded-3xl shadow-premium text-center max-w-3xl mx-auto border border-gray-100" data-id="element-223">
          <h4 className="text-xl font-bold text-deep-teal mb-4" data-id="element-224">
            What to Expect
          </h4>
          <p className="text-lg text-gray-700 leading-relaxed italic" data-id="element-225">
            "In just 7 days, you'll notice the 'brain fog' lifting, your clothes
            feeling looser around your waist, and for the first time in years,
            you'll wake up feeling like you actually slept. It's not magic—it's
            biology applied to your current stage of life."
          </p>
        </motion.div>
      </div>
    </section>;
}